import { useState } from "react";
import { FileText, X } from "lucide-react";
import { toast } from "sonner";
import { uploadDocumentChunked, formatBytes, apiError } from "@/lib/api";
import { labelCls } from "./ui";

const MAX = 1024 * 1024 * 1024;

export const DocUploadField = ({ kind, url, size, onChange, onBusy, privado = false, label = "" }) => {
  const [pct, setPct] = useState(null);
  const ext = kind.toLowerCase();

  const pick = async (e) => {
    const file = e.target.files[0];
    e.target.value = "";
    if (!file) return;
    if (!file.name.toLowerCase().endsWith(`.${ext}`)) return toast.error(`Selecciona un archivo .${ext}`);
    if (file.size > MAX) return toast.error("El archivo supera el máximo de 1 GB.");
    setPct(0); onBusy(true);
    try {
      const res = await uploadDocumentChunked(file, setPct, privado);
      onChange(res.url || res.upload_id, res.size, res);
      toast.success(`${kind} subido (${formatBytes(res.size)}).`);
    } catch (err) { toast.error(apiError(err)); } finally { setPct(null); onBusy(false); }
  };

  return (
    <div data-testid={`doc-field-${ext}`}>
      <label className={labelCls}>Archivo {kind}</label>
      {url && pct === null ? (
        <div className="flex items-center gap-2 rounded-lg border border-[#0f2544]/10 bg-[#f6f5f1] px-3 py-2 text-sm">
          <FileText size={15} className="text-[#1f44e0]" />
          {privado ? (
            <span className="flex-1 truncate text-[#0f2544]" data-testid={`doc-${ext}-link`}>{label || `${kind} subido`}{size ? ` · ${formatBytes(size)}` : ""}</span>
          ) : (
          <a href={url} target="_blank" rel="noreferrer" className="flex-1 truncate text-[#0f2544] hover:underline" data-testid={`doc-${ext}-link`}>
            {kind} subido{size ? ` · ${formatBytes(size)}` : ""}
          </a>
          )}
          <button type="button" onClick={() => onChange("", 0, null)} className="p-1 text-[#8a8a83] hover:text-red-600" data-testid={`doc-${ext}-remove`}><X size={14} /></button>
        </div>
      ) : pct !== null ? (
        <div data-testid={`doc-${ext}-progress`}>
          <div className="h-2 rounded-full bg-[#e7e5df] overflow-hidden"><div className="h-full bg-[#1f44e0] transition-[width] duration-300" style={{ width: `${pct}%` }} /></div>
          <p className="text-xs text-[#8a8a83] mt-1">Subiendo {kind}... {pct}% — no cierres esta ventana.</p>
        </div>
      ) : (
        <input type="file" accept={`.${ext}`} onChange={pick} className="text-sm" data-testid={`doc-${ext}-input`} />
      )}
    </div>
  );
};
